export const RECORDING_VIDEO_QUALITY = {
  LowQuality: 'video_lq',
  HighQuality: 'video_hq'
}
export const NOTIFICATION_CATEGORIES = {
  RECORDING: 'recording',
  REPORTS: 'reports'
}
export const NOTIFICATIONS_TYPE = {
  'recording-download': {
    name: 'recordingDownload',
    notificationType: 'recording-download',
    requiredPresignedLink: true,
    notificationTitle: 'recording-download',
    notificationCategory: NOTIFICATION_CATEGORIES.RECORDING
  },
  downloadDevicesDataUsageReport: {
    name: 'downloadDevicesDataUsageReport',
    notificationType: 'downloadDevicesDataUsageReport',
    notificationTitle: 'device-data-usage-report',
    requiredPresignedLink: true,
    notificationCategory: NOTIFICATION_CATEGORIES.REPORTS
  },
  downloadDevicesHealthReport: {
    name: 'downloadDevicesHealthReport',
    notificationType: 'downloadDevicesHealthReport',
    notificationTitle: 'device-health-report',
    requiredPresignedLink: true,
    notificationCategory: NOTIFICATION_CATEGORIES.REPORTS
  },
  downloadDevicesAlarmsReport: {
    name: 'downloadDevicesAlarmsReport',
    notificationType: 'downloadDevicesAlarmsReport',
    notificationTitle: 'device-alarms-report',
    requiredPresignedLink: true,
    notificationCategory: NOTIFICATION_CATEGORIES.REPORTS
  }
}
export const NOTIFICATION_DOWNLOAD_ACTIONS_TYPES = {
  VIEW_RECORDING_FILE: 'viewRecordingFile',
  DOWNLOAD_RECORDING_FILE: 'downloadRecordingFile',
  AUTO_DOWNLOAD_RECORDING_FILE: 'autoDownloadRecordingFile'
}

export const NOTIFICATION_CATEGORIES_TITLES = {
  recording: (meta, title) =>
    `${meta.imei}_${meta.streamId}_${meta.startTime}_${meta.duration}_${meta.quality}.mp4`,

  reports: (meta, title) => {
    const timeOfFile = meta.createdAt || meta.timestamp
    return `${title}-_${moment
      .utc(timeOfFile)
      .format('YYYY_MM_DD_hh_mm_ss')}.csv`
  }
}

export const DEFAULT_NOTIFICATION_INTERVAL = 60000 // 1 minute
export const SHORT_NOTIFICATION_INTERVAL = 20000 // 20 seconds
export const SHORT_NOTIFICATION_INTERVAL_DURATION = 30 * 60 * 1000 // 30 minutes
